import withAPIAction from 'helpers/withAPIAction'
import {
  RolePermissionListReq,
  CreateRolePermissionReq,
  DeleteRolePermissionReq,
  RefrshPermissionReq,
} from './types'
import {
  getRolePermissionListAction,
  createRolePermissionAction,
  deleteRolePermissionAction,
  refreshPermissionAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const rolePermissionListAPI = (data: RolePermissionListReq, token: string, xmid: any) => {
  return withAPIAction<RolePermissionListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rolePermissionList}`,
    data,
    token,
    xmid,
  })(getRolePermissionListAction)
}

export const createRolePermissionAPI = (data: CreateRolePermissionReq, token: string, xmid: string) => {
  return withAPIAction<CreateRolePermissionReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createRolePermission,
    data,
    token,
    xmid,
  })(createRolePermissionAction)
}

export const deleteRolePermissionAPI = (data: DeleteRolePermissionReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteRolePermission.replace(':id', data.id.toString())
  return withAPIAction<DeleteRolePermissionReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteRolePermissionAction)
}

export const refreshPermissionAPI = (data: RefrshPermissionReq, token: string) => {
  return withAPIAction<RefrshPermissionReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.refreshPermission}`,
    data,
    token,
  })(refreshPermissionAction)
}
